export namespace SpecificationCoverageActions {
    export class SetAllSpecificationCoverages {
      static readonly type = '[specificationCoverage] SetAllSpecificationCoverages';
      constructor() {}
    }
    export class SetMySpecificationCoverages {
      static readonly type = '[specificationCoverage] SetMySpecificationCoverages';
      constructor(public userId: string) {}
    }
  
    export class DeleteSpecificationCoverage {
      static readonly type = '[specificationCoverage] DeleteSpecificationCoverage';
      constructor(public specificationCoverageUid: string, public regBy: string) {}
    }

    export class UpdateItem {
      static readonly type = '[specificationCoverage] UpdateItem';
      constructor(public item: any) {}
    }

    export class ClearCache {
      static readonly type = '[specificationCoverage] ClearCache';
      constructor() {}
    }
  }
  